import React, { FC, useEffect } from 'react';
import { IconButton } from '../IconButton';
import { Location } from '../icon/icons/Location';
import { useGeoLocation } from '../../hooks/useGeoLocation';

interface NearMeProps {
  onChange: (...event: any[]) => void;
  checked: boolean;
}

export const NearMe: FC<NearMeProps> = ({ onChange, checked }) => {
  const { requestGeoLocation, location: geolLocation, clearGeoLocation } = useGeoLocation();

  const handleToggleLocation = () => {
    if (geolLocation?.lat || checked) {
      clearGeoLocation();
    } else {
      requestGeoLocation();
    }
  };

  useEffect(() => {
    if (onChange) {
      onChange(geolLocation);
    }
  }, [geolLocation]);
  return (
    <>
      <IconButton a11yTitle="Get location" onClick={handleToggleLocation} color={checked ? 'brand' : 'black'}>
        <Location />
      </IconButton>
    </>
  );
};
